import moment from "moment";

import { AssigneeStatus } from "@seneca/assignments-service-types";

import { OptionType, STATUS_CODES, TimeWindowType } from "./consts";

const format = "DD-MM-YY";
export const getCachedId = (timeWindow: TimeWindowType) => {
  const { start, end } = timeWindow;
  const startStr = start === null ? "null" : start!.format(format);
  const endStr = end === null ? "null" : end!.format(format);
  return `${startStr}-${endStr}`;
};

export const chosenOptionIsInThePast = (
  chosenOption: OptionType | null | undefined,
  now: moment.Moment
) => {
  return (
    chosenOption &&
    chosenOption.value &&
    chosenOption.value.end &&
    chosenOption.value.end.isSameOrBefore(now)
  );
};

export function getAssigneeStatusCode(
  isAfterDueDate: boolean,
  status?: string,
  totalStudyTime?: number
) {
  if (status === AssigneeStatus.complete) {
    return STATUS_CODES.completed;
  }

  if (status === AssigneeStatus.late) {
    return STATUS_CODES.late;
  }

  if (isAfterDueDate) {
    return STATUS_CODES.missed;
  }

  if (totalStudyTime) {
    return STATUS_CODES.inProgress;
  }

  return STATUS_CODES.notStarted;
}
